// 0 = deutsch, 1 = englisch, 2 = holland
export default {
  apps: ['apps_1', 'apps_2', 'apps_3', 'apps_4', 'apps_5', 'apps_6'],
  partnership: ['partnership_1', 'partnership_2', 'partnership_3', 'partnership_4'],
  fbads: ['fbads_1', 'fbads_2', 'fbads_3', 'fbads_4', 'fbads_5'],
  seo: ['seo_1', 'seo_2', 'seo_3', 'seo_4', 'seo_5'],
  pricing: ['pricing_1', 'pricing_2', 'pricing_3', 'pricing_4', 'pricing_5', 'pricing_6'],
  consult: ['consult_1', 'consult_2', 'consult_3', 'consult_4']
};
